// eslint-disable-next-line no-restricted-imports
import { Dimmer } from 'semantic-ui-react';

import { useTranslation } from 'react-i18next';
import { BillingPageEnum } from '../../../common';
import { SEGMENT_EVENTS, useSegmentTrack } from '../../../segment';

import { EmailIcon } from '@wonderschool/common-base-ui';

type EnablePaymentsModalProps = {
  page: string;
};

const EnablePaymentsModal: React.FC<EnablePaymentsModalProps> = ({ page }) => {
  const { t } = useTranslation();
  const segmentTrack = useSegmentTrack();

  function handleClick() {
    const segmentEventMap = {
      [BillingPageEnum.INVOICE]: SEGMENT_EVENTS.addPayoutAccountInvoiceEmail,
      [BillingPageEnum.INVOICE_PLAN]: SEGMENT_EVENTS.addPayoutAccountInvoicePlanEmail,
    };

    const segmentEvent = segmentEventMap[page] || '';

    segmentTrack(segmentEvent);
  }
  return (
    <>
      <Dimmer active inverted />
      <div className="enable-payments-modal">
        <b className="top-text">{t('billing.enablePayModal.topText')}</b>
        <>
          <li>{t('billing.enablePayModal.bullet1')}</li>
          <li>{t('billing.enablePayModal.bullet2')}</li>
        </>
        <div className="link-section">
          <a
            href="mailto:support@wonderschool.com"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-x-1"
            onClick={handleClick}
          >
            <EmailIcon className="size-6" />
            {t('support@wonderschool.com')}
          </a>
        </div>
      </div>
    </>
  );
};

export default EnablePaymentsModal;
